import React from "react";
import { QUADRANTS, QUADRANT_COLORS } from "../utils/calendarUtils";

const QuadrantView = ({ selectedDate, appointments, onAppointmentClick }) => {
  // Filter appointments for selected date
  const todayAppointments = appointments.filter(apt => {
    if (!apt.dateTime) return false;
    const aptDate = new Date(apt.dateTime);
    const selectedDateOnly = new Date(selectedDate);
    selectedDateOnly.setHours(0, 0, 0, 0);
    aptDate.setHours(0, 0, 0, 0);
    return aptDate.getTime() === selectedDateOnly.getTime();
  });

  // Group appointments by quadrant
  const appointmentsByQuadrant = QUADRANTS.reduce((acc, quadrant) => {
    acc[quadrant] = todayAppointments.filter(apt => apt.quadrant === quadrant);
    return acc;
  }, {});

  // Calculate percentages
  const total = todayAppointments.length;
  const percentageByQuadrant = QUADRANTS.reduce((acc, quadrant) => {
    const count = appointmentsByQuadrant[quadrant].length;
    acc[quadrant] = total > 0 ? Math.round((count / total) * 100) : 0;
    return acc;
  }, {});

  // Quadrant colors matching the legend
  const quadrantColors = QUADRANT_COLORS;

  const formatTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    let hours = d.getHours();
    const minutes = d.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${String(minutes).padStart(2, '0')}${period}`;
  };

  return (
    <div className="quadrant-view-container">
      <div className="quadrant-grid">
        {QUADRANTS.map((quadrant, index) => {
          const config = quadrantColors[quadrant];
          const quadrantAppts = appointmentsByQuadrant[quadrant];
          const percentage = percentageByQuadrant[quadrant];
          
          return (
            <div 
              key={quadrant}
              className="quadrant-block"
              style={{
                background: config.bg,
                borderColor: config.border
              }}
            >
              <div className="quadrant-header" style={{ borderBottomColor: config.color }}>
                <span className="quadrant-number" style={{background: config.border}}>{index + 1}</span>
                <h3 className="quadrant-title" style={{color: config.color}}>{quadrant}</h3>
              </div>
              
              <div className="quadrant-percentage">{percentage}%</div>
              
              <div className="quadrant-appointments">
                {quadrantAppts.length > 0 ? (
                  quadrantAppts.map(apt => {
                    const aptConfig = quadrantColors[apt.quadrant] || config;
                    return (
                      <div 
                        key={apt.id}
                        className="quadrant-appointment-item"
                        onClick={() => onAppointmentClick(apt)}
                        style={{ 
                          borderLeftColor: aptConfig.border,
                          background: aptConfig.color
                        }}
                      >
                        <div className="appointment-time-title">
                          <span className="appt-time">{formatTime(apt.dateTime)}</span>
                          <span className="appt-title">{apt.title}</span>
                        </div>
                        {apt.type && <div className="appt-type">{apt.type}</div>}
                      </div>
                    );
                  })
                ) : (
                  <div className="no-appointments">No appointments</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="quadrant-legend">
        <div className="legend-item">
          <div className="legend-color" style={{ background: quadrantColors["Urgent/Important"].color }}>
            <span className="legend-number">1</span>
          </div>
          <span className="legend-text">Urgent/Important</span>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ background: quadrantColors["Not Urgent/Important"].color }}>
            <span className="legend-number">2</span>
          </div>
          <span className="legend-text">Not Urgent/Important</span>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ background: quadrantColors["Urgent/Not Important"].color }}>
            <span className="legend-number">3</span>
          </div>
          <span className="legend-text">Urgent/Not Important</span>
        </div>
        <div className="legend-item">
          <div className="legend-color" style={{ background: quadrantColors["Not Urgent/Not Important"].color }}>
            <span className="legend-number">4</span>
          </div>
          <span className="legend-text">Not Urgent/Not Important</span>
        </div>
      </div>
    </div>
  );
};

export default QuadrantView;
